import React from 'react';
import { useEffect } from 'react';

import { Form, Input, Spin, Space, Button, message } from 'antd';

import sessionManager, { eVariableType } from '../../../SessionManager';
import api from '../../../api';
import stringres from '../../../translations/stringres';
import '../../Antd.css';
import CmbGenerico from '../../Combos/CmbGenerico';

export default function ContattiAddEdit(props) {
    const { onCancel } = props;
    const { codCliente } = props;
    const { idContatto } = props;
    console.log('idContatto', idContatto);
    const [form] = Form.useForm();

    useEffect(() => {
        if (idContatto != null) {
            caricaContatto();
        }
    }, []);

    async function salvaContatto() {
        try {
            const data = {
                idContatto: idContatto,
                codCliente: codCliente,
                idSocieta: sessionManager.get(eVariableType.IDSocieta),
                idTipoContatto: form.getFieldValue('idTipoContatto'),
                descrizioneContatto: form.getFieldValue('descrizioneContatto'),
                nomeComposto: form.getFieldValue('nomeComposto'),
                email: form.getFieldValue('email'),
                telefono: form.getFieldValue('telefono'),
                cellulare: form.getFieldValue('cellulare'),
            };

            const result = await api.post('CRM/Clienti/Contatti/InsertUpdate', data);
            if (result != null && result.data != null) {
                message.success('successo');
                form.resetFields();

                onCancel(true);
            }
        } catch (error) {}
    }

    async function caricaContatto() {
        try {
            const result = await api.get(
                'CRM/Clienti/Contatto?idContatto=' +
                    idContatto +
                    '&idSocieta=' +
                    sessionManager.get(eVariableType.IDSocieta)
            );

            if (result != null && result.data != null) {
                form.setFieldValue('idTipoContatto', result.data.idTipoContatto);
                form.setFieldValue('descrizioneContatto', result.data.descrizioneContatto);
                form.setFieldValue('nomeComposto', result.data.nomeComposto);
                form.setFieldValue('email', result.data.email);
                form.setFieldValue('telefono', result.data.telefono);
                form.setFieldValue('cellulare', result.data.cellulare);
            }
        } catch (error) {
            message.error(error.result.data.message);
        }
    }

    function onFinish() {
        salvaContatto();
    }

    function onChangeEvent(value) {
        form.setFieldsValue('idTipoContatto', value);
    }

    return (
        <div>
            <Form form={form} layout="vertical" onFinish={onFinish}>
                <Form.Item name="descrizioneContatto" rules={[{ required: true }]}>
                    <Input placeholder={stringres.t('descrizione')} />
                </Form.Item>
                <Form.Item name="nomeComposto" rules={[{ required: true }]}>
                    <Input placeholder={stringres.t('ragioneSociale')} />
                </Form.Item>
                <Form.Item name="idTipoContatto" rules={[{ required: true }]}>
                    <CmbGenerico
                        value={!form ? form.getFieldValue('idTipoContatto') : null}
                        placeholder={stringres.t('tipocontatto')}
                        onChange={(value) => form.setFieldsValue({ idTipoContatto: value })}
                        queryurl="CRM/Clienti/ContattoTipi"
                        insertupdateurl="CRM/Clienti/ContattoTipo/InsertUpdate"
                        deleteurl="CRM/Clienti/ContattoTipo/Delete"
                        campoid="idTipoContatto"
                        campoidSocieta="idSocieta"
                        campoDescrizione="descrizione"
                    ></CmbGenerico>
                </Form.Item>
                <Form.Item
                    rules={[{ type: 'email', message: stringres.t('emailnonvalida') }]}
                    className="Form-item-inline2componenti"
                    name="email"
                >
                    <Input placeholder={stringres.t('email')} />
                </Form.Item>
                <Form.Item>
                    <Form.Item className="Form-item-inline" name="telefono">
                        <Input placeholder={stringres.t('telefono')} />
                    </Form.Item>
                    <Form.Item className="Form-item-inline" name="cellulare">
                        <Input placeholder={stringres.t('telefono') + ' 2'} />
                    </Form.Item>
                </Form.Item>
                {/* <Form.Item name='posizione' >
                    <Input placeholder={stringres.t('posizione')} />
                </Form.Item> */}
                <Form.Item style={{ textAlign: 'end', marginTop: '15px' }}>
                    <Space>
                        <Button style={{ width: '120px' }} type="primary" htmlType="submit">
                            {stringres.t('conferma')}
                        </Button>
                        <Button style={{ width: '120px' }} type="primary" onClick={onCancel}>
                            {stringres.t('annulla')}
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </div>
    );
}
